// extracted by mini-css-extract-plugin
export default {"errors_wrap":"error_errors_wrap__Bc+U6"};